import { WindowService } from './../../services/window.service';
import { SuiModalService } from 'ng2-semantic-ui';
import { ConfirmModal } from './../confirm-modal/confirm-modal.component';
import { BountyService } from './../../services/bounty.service';
import { ActivatedRoute } from '@angular/router';
import { Comment } from './../comments/comments-section/comments-section.component';
import { Bounty } from './../../interfaces/Bounty';
import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';

export const CLAIM_STATUS_COLORS = {
  new: 'yellow',
  denied: 'red',
  withdrawn: 'red',
  accepted: 'green',
};

@Component({
  selector: 'app-view-claim',
  templateUrl: './view-claim.component.html',
  styleUrls: ['./view-claim.component.scss'],
})
export class ViewClaimComponent implements OnInit {
  public bounty: Bounty;
  public bountyClaim: {
    id: number;
    comments: Comment[];
    created_at: Date;
    updated_at: Date;
    claimer: any;
    status: 'new' | 'withdrawn' | 'denied' | 'accepted';
    user_id: number;
  };
  public isOwner: boolean;
  private user: any;

  constructor(
    private route: ActivatedRoute,
    private bountyService: BountyService,
    private userService: UserService,
    private modalService: SuiModalService,
    private windowService: WindowService,
  ) {}

  ngOnInit() {
    // Get initial pre-rendered data from window object
    const preRenderedData = this.windowService.appData;
    this.user = this.userService.getUser();

    if (preRenderedData) {
      this.mapDataToState(preRenderedData);
    } else {
      this.fetch();
    }
  }

  get isClaimer() {
    return (
      this.user && this.bountyClaim && this.user.id === this.bountyClaim.user_id
    );
  }

  private mapDataToState({ bounty, bountyClaim }) {
    const user = this.userService.getUser();

    this.bounty = bounty;
    this.bountyClaim = bountyClaim;
    this.isOwner = user && user.id === this.bounty.user_id;
  }

  private async fetch() {
    const id = this.route.snapshot.paramMap.get('id');
    const { bounty, bountyClaim } = await this.bountyService.getClaim(id);
    this.mapDataToState({ bounty, bountyClaim });
  }

  public async acceptClaim() {
    this.modalService
      .open(
        new ConfirmModal(
          'Accept Claim',
          `Are you sure you want to accept this claim?
         This will set the user as the winner of the bounty.`,
        ),
      )
      .onApprove(async () => {
        await this.bountyService.setClaimWinner(this.bountyClaim.id);
        await this.fetch();
      });
  }

  public async denyClaim() {
    this.modalService
      .open(
        new ConfirmModal(
          'Deny Claim',
          'Are you sure you want to deny this claim?',
        ),
      )
      .onApprove(async () => {
        await this.bountyService.denyClaim(this.bountyClaim.id);
        await this.fetch();
      });
  }

  public async markPaymentReceived() {
    this.modalService
      .open(
        new ConfirmModal(
          'Mark payment received',
          'Are you sure you want to mark payment received?',
        ),
      )
      .onApprove(async () => {
        await this.bountyService.markPaymentReceived(this.bountyClaim.id);
        await this.fetch();
      });
  }

  get canAccept() {
    const isMod = this.user && this.user.isMod;

    if (this.bounty.payment_type === 'pool') {
      return isMod;
    }

    return this.bountyClaim.status === 'new' && (isMod || this.isOwner);
  }

  get canDenyOrCancel() {
    return this.bountyClaim.status === 'new';
  }

  get canMarkPaymentReceived() {
    return (
      (!this.isOwner || this.user.isMod) &&
      this.bountyClaim.status === 'accepted' &&
      this.bounty.status === 'winner-chosen'
    );
  }

  get hasActions() {
    return (
      this.canAccept || this.canDenyOrCancel || this.canMarkPaymentReceived
    );
  }

  get statusColor() {
    return CLAIM_STATUS_COLORS[this.bountyClaim.status];
  }
}
